__turbopack_context__.v({
  "fade-in": "BlockMediaAccordionItemMedia-module-scss-module__yZyyjG__fade-in",
  "fade-out": "BlockMediaAccordionItemMedia-module-scss-module__yZyyjG__fade-out",
  "isActive": "BlockMediaAccordionItemMedia-module-scss-module__yZyyjG__isActive",
  "isMounted": "BlockMediaAccordionItemMedia-module-scss-module__yZyyjG__isMounted",
  "isPrevious": "BlockMediaAccordionItemMedia-module-scss-module__yZyyjG__isPrevious",
  "media": "BlockMediaAccordionItemMedia-module-scss-module__yZyyjG__media",
  "root": "BlockMediaAccordionItemMedia-module-scss-module__yZyyjG__root",
  "videoPlayButton": "BlockMediaAccordionItemMedia-module-scss-module__yZyyjG__videoPlayButton",
});
